import { Environment } from '@models';
import { environment as rootEnvironment } from '../../../../environments/environment.development';

export const environment: Environment = {
  ...rootEnvironment,
  role: 'Admin',
  googleMapsApiKey: 'AIzaSyANmnAElEXRGvXqPa3uiL__jYTO3ZxtpP8',
  googleOauthClientId:
    '367721017562-8k8e5ft6kk3mht51arvt18p97q3pk9t7.apps.googleusercontent.com',
  zoomOauthClientId: 'PWT8mc8gSYeiueSlFYdFA',
  microsoftOauthClientId: '824fa48b-1d23-4483-8807-538e258be9d5',
  microsoftOauthTenantId: '2af88f65-bc72-4ccd-8711-f11e4691f4fb',
};
